import React from 'react';

export default function Next() {
  return (
    <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 17L8.58052 9.94281C9.13983 9.42211 9.13983 8.57789 8.58052 8.05719L1 1"
        stroke="#121212"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
